import { Stack, Box } from "@mui/material";
import React, { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { EmbedsContainer } from "./EmbedsContainerV2";
import { IEmbed } from "./interface";
import { LoadMoreBtn } from "../../../../components/Loader";

interface Props {
  loading: boolean;
  embeds: IEmbed[];
  error?: string | null;
  count: number;
  onDeleteEmbed?: (i: number) => any;
}

export const StoriesList: FC<Props> = ({ count, ...rest }) => {
  const { embeds } = rest;
  const [, setSearchParams] = useSearchParams();

  const handleSelectEmbed = (embed: IEmbed) => {
    const { id } = embed;
    if (typeof id === "number") {
      setSearchParams((prev) => {
        prev.set("embed", id.toString());
        return prev;
      });
    }
  };

  const loadMore = () => {
    setSearchParams((params) => {
      params.set("limit", String(embeds.length + 20));
      return params;
    });
  };

  return (
    <Stack direction="row" alignItems="top">
      <Box
        flexGrow={1}
        sx={{
          overflow: "visible",
          paddingRight: "16px",
          marginRight: "16px",
        }}
      >
        <Box
          sx={{
            overflow: "visible",
            marginRight: "-30px",
          }}
        >
          <EmbedsContainer {...rest} onSelectEmbed={handleSelectEmbed} />
        </Box>
        {Array.isArray(embeds) && embeds.length < count && (
          <LoadMoreBtn onClick={loadMore} loading={rest.loading} />
        )}
      </Box>
    </Stack>
  );
};
